module.exports = __webpack_public_path__ + "static/media/IMG_20240523_144339-min.7826eb41.jpg";